/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Amplify, { Auth } from 'aws-amplify';
import awsExports from './aws-exports';
import { requestAdminTokenRefresh } from './lti/openedxAdmin/adminTokenRefresh';
Amplify.configure(awsExports);

Amplify.configure({
  API: {
    graphql_endpoint: process.env.REACT_APP_QUERY_DOMAIN,
    graphql_headers: async () => {
      try {
        const session = await Auth.currentSession();
        return {
          Authorization: session.getIdToken().getJwtToken(),
        };
      } catch (err) {
        // The OpenEdX admin-dashboard session is built with an empty Cognito
        // refresh token (see lti/openedxAdmin/login.tsx), so Amplify can never
        // refresh it on its own — ask the embedding host for a fresh one instead.
        if (sessionStorage.getItem('domainName') === 'openedx') {
          try {
            const freshToken = await requestAdminTokenRefresh();
            return { Authorization: freshToken };
          } catch (refreshErr) {
            console.error('Error refreshing OpenEdX admin session', refreshErr);
          }
        }
        console.error('Error getting current Cognito session, falling back to stored token', err);
        return {
          Authorization: localStorage.getItem('ReactAmplify.TokenKey') || '',
        };
      }
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

serviceWorker.unregister();
